import { NAME_SPACES } from "shared/locales/constants";
import reserves from "./reserves";

const translation = {
  [NAME_SPACES.PUBLIC.RESERVES]: reserves,
};

export default translation;
